export const sanitizeCep = (value = '') => String(value).replace(/\D/g, '');

export const searchCep = async (rawCep) => {
    const cep = sanitizeCep(rawCep);

    if (cep.length !== 8) {
        throw new Error('CEP inválido.');
    }

    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    const data = await response.json();

    if (!response.ok || data.erro) {
        throw new Error('CEP não encontrado.');
    }

    return {
        cep,
        logradouro: data.logradouro || '',
        complemento: data.complemento || '',
        bairro: data.bairro || '',
        cidade: data.localidade || '',
        uf: data.uf || '',
        code_ibge_cidade: data.ibge || '',
        code_ibge_uf: data.ibge ? data.ibge.slice(0, 2) : '',
    };
};
